module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showLogin) ? _c('div', [_c('login', {
    model: {
      value: (_vm.showLogin),
      callback: function($$v) {
        _vm.showLogin = $$v
      },
      expression: "showLogin"
    }
  })], 1) : _c('div', [_c('home')], 1), _vm._v(" "), _c('footer', [_c('el-row', {
    staticClass: "footer",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('strong', [_vm._v("Tower Management System")]), _vm._v(" "), _c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "static/favicon.png"
    }
  }), _vm._v(" \n        © "), _c('a', {
    attrs: {
      "href": "https://xolas.io",
      "target": "_blank"
    }
  }, [_vm._v("Xolas Sdn Bhd")]), _vm._v(" " + _vm._s(_vm.year)), _c('br'), _vm._v("\n        Version " + _vm._s(this.version) + " "), _c('span', {
    staticClass: "text-muted hidden-sm-and-down"
  }, [_vm._v("| Desktop mininum resolution 1024 x 960.")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("All data on this site belongs to "), _c('strong', [_vm._v(_vm._s(this.xolasClient().name))]), _vm._v(". It can only be used in accordance with their policies.")]), _c('br')])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60ab447d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1521
// module chunks = 0